import { Dispatch } from "react";

export const enum LoadingPhase {
  Loading = "loading",
  Complete = "complete",
  Error = "error",
  Ready = "ready",
}

export const NEW_LEARNING_ACTION_TYPE = {
  LOADER_SHOW_AND_HIDE: "loader/showandhide",
  ALERT_SHOW: "alert/show",
} as const;

export const NEW_LEARNING_ALERT_TYPE = {
  SUCCESS: "success",
  ERROR: "error",
} as const;

type NewLearningAlertType = (typeof NEW_LEARNING_ALERT_TYPE)[keyof typeof NEW_LEARNING_ALERT_TYPE];

interface Altertdetails {
  type: NewLearningAlertType;
  title: string;
  message: string;
}

type NewLearningActionPayload = {
  [NEW_LEARNING_ACTION_TYPE.LOADER_SHOW_AND_HIDE]: {
    show: boolean;
    message?: string;
  };
  [NEW_LEARNING_ACTION_TYPE.ALERT_SHOW]: Altertdetails;
};

export const showAction = <T extends keyof NewLearningActionPayload>(
  dispatch: Dispatch<any>,
  type: T,
  payload: NewLearningActionPayload[T],
) => {
  dispatch({
    type,
    payload,
  });
};

export const focusFirstError = (
  errors: Record<string, any>,
  questionRefs: Record<string, HTMLDivElement | null>,
) => {
  const firstErrorQuestionId = Object.keys(errors).find(
    (questionId) => Object.keys(errors[questionId]).length > 0,
  );

  if (firstErrorQuestionId && questionRefs[firstErrorQuestionId]) {
    const container = questionRefs[firstErrorQuestionId];
    const focusableElement = container?.querySelector<HTMLElement>(
      'input, select, textarea, button, [tabindex]:not([tabindex="-1"])',
    );

    if (focusableElement) {
      setTimeout(() => {
        focusableElement.focus();
        focusableElement.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 100);
    }
  }
};
